// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-no-content',
  standalone: true,
  imports: [NgOptimizedImage, TranslateModule],
  templateUrl: './no-content.component.html',
  styleUrl: './no-content.component.scss',
})
export class NoContentComponent {
  // inputs
  message = input.required<string>();
}
